import { useEffect, useState } from "react";
import { useApi } from "@/lib/api";

export function AuthImage({ src, alt = "", className = "", testId }) {
  const api = useApi();
  const [url, setUrl] = useState("");
  useEffect(() => {
    let obj = "";
    let live = true;
    api.get(src, { responseType: "blob" }).then((r) => {
      obj = URL.createObjectURL(r.data);
      if (live) setUrl(obj);
    }).catch(() => {});
    return () => { live = false; if (obj) URL.revokeObjectURL(obj); };
  }, [api, src]);
  if (!url) return <div className={`animate-pulse bg-neutral-200/20 ${className}`} data-testid={testId} />;
  return <a href={url} target="_blank" rel="noreferrer"><img src={url} alt={alt} className={className} data-testid={testId} /></a>;
}
